
export default function getNLS(krString) {
    var returnVar;
    if(!process.browser) return '';

    if (
        localStorage['NLS'] 
        && localStorage['NLS'] == 'vietnam'
    ) returnVar = TranslateData[krString];
    else returnVar = krString;


    // console.log("getNLS: ", krString, returnVar);
    return returnVar;
}

// i18n용 원본데이터
const TranslateData_bk0610 = {
    "캠스콘":"CAMSCON", 
    "매거진": "Tạp chí",
    "커뮤니티": "Cộng đồng",
    "키워드 입력": "Nhập từ khóa",
    "아래에서 선택": "chọn dưới đây",
    "전체": "Tất cả",
    "에디토리얼(화보)": "Biên tập ( Họa báo)",
    "패션": "Thời trang",
    "뷰티": "Làm đẹp",
    "스니커즈": "Giày thể thao",
    "뮤직": "Âm nhạc",
    "피처": "Phóng sự",
    "인터뷰": "Phỏng vấn",
    "라이프": "Đời sống",
    "테크": "Công nghệ",
    "스포츠": "Thể thao",
    "한국어": "Tiếng Hàn",
    "베트남어": "Tiếng Việt",
    "인기 기사": "Tin nóng",
    "인기 포스팅": "Bài viết phổ biến",
    "추천 기사": "Tin đề cử",
    "인기순": "Theo độ phổ biến",
    "최신순": "Theo độ mới nhất",
    "팔로잉순": "Theo độ theo dõi",
    "필터": "Bộ lọc",
    "기사 더 보기": "Xem thêm tin",
    "더 보기": "xem thêm",
    "인재 채용": "Tuyển dụng nhân tài",
    "편집 팀": "Tổ biên tập",
    "컨트리뷰터": "Cộng tác viên",
    "이용약관": "Điều khoản sử dụng",
    "개인정보 처리방침": "Chính sách bảo mật thông tin cá nhân",
    "서울시 강남구 압구정로60길 26,2층": "Thành phố Seoul,quận Kangnam,đường Apgujeong số 60>>26,tầng 2",
    "캠퍼스": "Học đường",
    "스트리트": "Phố",
    "페스티벌": "Lễ hội",
    "브랜드": "Thương hiệu",
    "둘러보기": "Xem thêm",
    "필터 >>원하시는 조건을 선택해서 적용해주세요.": "Bộ lọc – Hãy lựa chọn điều kiện mong muốn và áp dụng",
    "성별": "Giới tính",
    "전체": "tất cả",
    "남자": "nam",
    "여자": "nữ",
    "같이": "cả hai",
    "기타": "khác",
    "계절": "Mùa",
    "전체": "Tất cả",
    "봄": "Xuân",
    "여름": "Hạ",
    "가을": "Thu",
    "겨울": "Đông",
    "컬러": "Màu sắc",
    "원래대로": "Quay lại như cũ",
    "적용": "Áp dụng",
    "해시태그": "Gắn thẻ",
    "브랜드": "Thương hiệu",
    "장소": "Địa điểm",
    "사용자": "Người sử dụng",
    "라이크": "Thích",
    "스크랩": "Trích dẫn",
    "댓글": "Bình luận",
    "팔로워": "Theo dõi",
    "팔로잉": "Đang theo dõi",
    "13 게시물": "13 bài viết",
    "검색된 결과가 없습니다.": "Không có kết quả tìm kiếm",
    "캠스콘은 20대들의 패션사진,데일리룩 커뮤니티입니다.": "CAMSCON là cộng đồng ảnh thời trang và phong cách hàng ngày.",
    "여러분의 사진도 공유해주세요!":"Mọi người hãy chia sẻ ảnh của mình nào!",
};


const TranslateData_bk0627 = {
    "년": "năm",
    "월": "tháng",
    "일": "ngày",
    "5분 전": "5 phút trước",
    "5시간 전": "5 tiếng trước",
    "5일 전": "5 ngày trước",
    "5주 전": "5 tuần trước",
    "5개월 전": "5 tháng trước",
    "결과가 없습니다.": "Không có kết quả",
    "검색된 결과가 없습니다.": "Kết quả tìm kiếm không có",
    "키워드 입력, 아래에서 선택": "Nhập từ khóa, Chọn từ bên dưới",
    "에디토리얼": "Biên tập",
    "스페셜아티클": "đặc biệt Bài báo",
    "칼럼": "cột báo",
    "인터뷰": "Phỏng vấn",
    "피쳐": "Đặc điểm",
    "패션": "Phong cách thời trang",
    "뷰티": "Vẻ đẹp",
    "스니커즈": "Giày thể thao",
    "액세서리": "Phụ kiện",
    "뮤직": "Âm nhạc",
    "테크": "Kỹ thuật",
    "푸드": "Ẩm thực",
    "아트": "Mỹthuật",
    "자동차": "Xe ô tô",
    "토이": "Đồ chơi",
    "영화": "Phim",
    "스포츠": "Thể thao",
    "기타": "Khác",
    "오픈소스 라이센스": "Giấy phép mã nguồn mở",
    "서울시 강남구 압구정로60길 26, 2층": "Tầng 2, số 26 đường Apgujeong60, quận Gangnam, Thành phố Seoul",
    "추천 기사": "Bài báo đề xuất",
    "둘러보기": "Khám phá",
    "필터": "Bộ lọc",
    "원하시는 조건을 선택해서 적용해주세요.": "Lựa chọn và áp dụng điều kiện mong muốn",
    "캠스콘 둘러보기": "Khám phá CAMSCON",
    "캠스콘은 20대들의 패션사진, 데일리룩 커뮤니티입니다. 여러분의 사진도 공유해주세요!": "CAMSCON là cộng đồng chia sẻ ảnh thời trang, câu chuyện hàng ngày dành cho các bạn trẻ tuổi 2o. Hãy chia sẻ hình ảnh của các bạn!",
    "포스트": "Bài đăng",
    "스크랩": "Bài trích",
    "설정": "Cài đặt",
    "로그아웃": "Đăng xuất",
    "취소": "Hủy",
    "팔로워": "Người theo dõi",
    "팔로잉": "Đang theo dõi",
    "XX 게시물": "Bài đăng XX",
    "회원님의 게시글에 댓글을 달았습니다.": "Có nhận xét về bài đăng của bạn.",
    "회원님의 사진을 좋아합니다.": "“Thích” ảnh của bạn.",
    "회원님을 팔로우 합니다.": "Theo dõi bạn.",
    "프로필 수정": "Chỉnh sửa hồ sơ",
    "닉네임": "Bí danh (nickname)",
    "선택안함": "Không chọn",
    "남성": "Nam",
    "여성": "Nữ",
    "생년월일": "Ngày sinh",
    "년, 월, 일": "Năm, tháng, ngày (Ngày, tháng, năm)",
    "자기소개, 최대 30자까지 입력 가능합니다.": "Giới thiệu bản thân, có thẻ nhập tối đa 30 chữ. ",
    "인스타그램": "Instagram",
    "개인홈페이지": "Trang cá nhân",
    "CAMSCON 탈퇴하기": "Hủy đăng ký CAMSCON",
    "수정하기": "Chỉnh sửa",
    "비밀번호 변경": "Đổi mật khẩu",
    "현재 비밀번호": "Mật khẩu hiện tại",
    "현재 비밀번호를 입력해주세요.": "Hãy nhập mật khẩu hiện tại.",
    "새로운 비밀번호 입력": "Nhập mật khẩu mới",
    "영문, 숫자, 특수문자 포함 8~25자": "8~25 ký tự bao gồm tiếng Anh, số và ký tự đặc biệt",
    "새로운 비밀번호 한번 더 입력": "Nhập lại mật khẩu mới",
    "의견보내기": "Gửi ý kiến",
    "사용자 의견": "Ý kiến người dùng",
    "연락받으실 이메일": "Email để liên hệ",
    "선택, 예)": "Lựa chọn, Ví dụ)",
    "연락받으실 전하번호": "Số điện thoại liên hệ",
    "개인정보 활용에 동의합니다.": "Tôi đồng ý với việc sử dụng thông tin cá nhân.",
    "보내기": "Gửi",
    "이용가이드": "Hướng dẫn sử dụng",
    "공지사항": "Nội dung thông báo",
    "게시물": "Bài đăng",
    "업로드": "Tải lên ",
    "업로드 할 사진을 추가해 주세요.": "Hãy thêm ảnh để tải lên",
    "리스트에 없는 브랜드 추가 요청": "Yêu cầu thêm thương hiệu không có trong danh sách",
    "리스트에 없는 장소 추가 요청": "Yêu cầu thêm địa điểm không có trong danh sách",
    "다음": "Tiếp theo",
    "브랜드 입력": "Nhập thương hiệu",
    "브랜드 명을 영문 입력 후 선택": "Nhập tên thương hiệu bằng tiếng Anh và lựa chọn",
    "제품을 구매할 수 있는 URL 입력": "Nhập URL dẫn đến trang có thể mua sản phẩm",
    "저장": "Lưu",
    "취소": "Hủy",
    "타이틀은 최대 50자까지 입력 가능(필수)": "Tiêu đề có thể nhập tối đa 50 ký tự (bắt buộc)",
    "서브타이틀은 최대 100자까지 입력 가능": "Phụ đề có thể nhập tối đa 100 ký tự",
    "사진에 대한 내용을 입력": "Mô tả nội dung về hình ảnh",
    "해시태그": "Hashtag",
    "태그의 구분은 ','을 활용": "Sử dụng dấu “,” để phân loại thẻ",
    "촬영 장소": "Địa điểm chụp",
    "사진을 촬영한 장소를 입력": "Nhập vị trí chụp ảnh",
    "컬러": "Màu",
    "이 기사를 대표하는 컬러 혹은 첫 번째 이미지의 컬러를 선택": "Chọn màu chủ đề cho bài viết hoặc màu cho hình ảnh đầu tiên",
    "시즌": "Mùa",
    "봄": "mùa xuân",
    "여름": "mùa hạ",
    "가을": "mùa thu",
    "겨울": "mùa đông",
    "성별": "Giới tính",
    "남자": "nam",
    "여자": "nữ",
    "같이": "đồng giới",
    "기타": "dị giới",
    "이전": "Về trước",
    "업로드": "Tải lên",
}


export const TranslateData = {
    "매거진": "Tạp chí",
    "커뮤니티": "Cộng đồng",
    "키워드 입력, 아래에서 선택": "Nhập từ khóa, chọn dưới đây",
    "전체": "tất cả",
    "에디토리얼": "Biên tập",
    "스페셜아티클": "đặc biệt Bài báo",
    "칼럼": "cột báo",
    "인터뷰": "Phỏng vấn",
    "피쳐": "Thời trang",
    "패션": "Làm đẹp",
    "뷰티": "Vẻ đẹp",
    "스니커즈": "Giày thể thao",
    "액세서리": "Phụ kiện",
    "뮤직": "Âm nhạc",
    "테크": "Kỹ thuật",
    "푸드": "Ẩm thực",
    "아트": "Mỹthuật",
    "자동차": "Xe ô tô",
    "토이": "Xe ô tô",
    "영화": "Phim",
    "스포츠": "Thể thao",
    "기타": "Khác",
    "인기 기사": "Tin nóng",
    "인기순": "Theo độ phổ biến",
    "최신순": "Theo độ mới nhất",
    "분 전": "phút trước",
    "시간 전": "tiếng trước",
    "일 전": "ngày trước",
    "주 전": "tuần trước",
    "개월 전": "tháng trước",
    "년": "năm",
    "월": "tháng",
    "일": "ngày",
    "기사 더 보기": "Xem thêm tin",

    "추천 기사": "Tin đề cử",
    "인재 채용": "Tuyển dụng nhân tài",
    "오픈소스 라이센스": "Giấy phép mã nguồn mở",
    "편집 팀": "Tổ biên tập",
    "이용약관": "Điều khoản sử dụng",
    "개인정보 처리방침": "Chính sách bảo mật thông tin cá nhân",
    "서울시 강남구 압구정로60길 26, 2층": "Thành phố Seoul, quận Kangnam, đường Apgujeong số 60-26, tầng 2",
    "캠퍼스": "Học đường",
    "스트리트": "Phố",
    "페스티벌": "Lễ hội",
    "브랜드": "Thương hiệu",
    "팔로잉순": "Theo độ theo dõi",
    "인기 포스팅": "Bài viết phổ biến",
    "필터": "Bộ lọc",
    "원하시는 조건을 선택해서 적용해주세요.": "Hãy lựa chọn điều kiện mong muốn và áp dụng",
    "성별": "Giới tính",
    "전체": "tất cả",
    "남자": "nam",
    "여자": "nữ",
    "같이": "cả hai",
    "기타": "khác",
    "시즌": "Mùa",
    "봄": "Xuân",
    "여름": "Hạ",
    "가을": "Thu",
    "겨울": "Đông",
    "컬러": "Màu sắc",
    "원래대로": "Quay lại như cũ",
    "적용": "Áp dụng",
    "둘러보기": "Khám phá",
    "캠스콘 둘러보기": "Khám phá CAMSCON",
    "캠스콘은 20대들의 패션사진, 데일리룩 커뮤니티입니다. 여러분의 사진도 공유해주세요!": "CAMSCON là cộng đồng chia sẻ ảnh thời trang, câu chuyện hàng ngày dành cho các bạn trẻ tuổi 2o. Hãy chia sẻ hình ảnh của các bạn!",
    "검색된 결과가 없습니다.": "Kết quả tìm kiếm không có",
    "해시태그": "Gắn thẻ",
    "브랜드": "Thương hiệu",
    "장소": "Địa điểm",
    "사용자": "Người sử dụng",

    "라이크": "Thích",
    "댓글": "Bình luận",
    "등록": "nhập",
    "링크가 복사되었습니다": "Liên kết đã được sao chép",
    "게시글을 삭제하시겠습니까?": "Bạn có chắc chắn muốn xóa bài viết không?",
    "더 보기": "Xem thêm",

    "포스트": "Bài đăng",
    "스크랩": "Bài trích",
    "설정": "Cài đặt",
    "로그아웃": "Đăng xuất",
    "취소": "Hủy",
    "팔로워": "Người theo dõi",
    "팔로잉": "Đang theo dõi",
    "게시물": "Bài đăng",
    "결과가 없습니다.": "Không có kết quả",

    "카카오로 계속하기": "Đăng nhập bằng KAKAO",
    "이메일(아이디)": "Email(ID)",
    "가입하신 이메일 입력, 예)example@gmail.com": "Nhập email đã đăng ký của bạn, ví dụ: example@gmail.com",
    "비밀번호": "mật khẩu",
    "올바르지 않은 이메일 형식입니다.": "Định dạng email không hợp lệ.",
    "비밀번호는 8자리 이상이어야 합니다.": "Mật khẩu phải có ít nhất 8 chữ số.",
    "비밀번호는 숫자가 최소 1개씩 포함되어야 합니다.": "Mật khẩu phải chứa ít nhất một số.",
    "비밀번호를 잊으셨나요?": "Quên mật khẩu?",
    "로그인": "đăng nhập",
    "아직 캠스콘 회원이 아니신가요?": "Bạn chưa phải là thành viên CAMSCON?",
    "카카오로 시작하기": "Bắt đầu với KAKAO",
    "아이디로 사용하실 이메일 입력, 예)example@gmail.com": "Nhập email sẽ được sử dụng làm ID, ví dụ: example@gmail.com",
    "영문, 숫자, 특수문자 각각 1회 포함(8자 이상)": "Bao gồm 1 ký tự tiếng Anh, số và đặc biệt (8 ký tự trở lên)",
    "비밀번호 확인, 동일한 비밀번호 재입력": "Xác nhận mật khẩu, nhập lại cùng một mật khẩu",
    "닉네임": "tên nick",
    "최대 12자, 공백 허용안됨": "Tối đa 12 ký tự, không được phép có khoảng trắng",
    "이용약관 동의": "Chấp nhận các điều khoản và điều kiện",
    "약관보기": "Xem điều khoản",
    "개인정보처리방침 동의": "Tôi đồng ý với chính sách bảo mật",
    "회원가입": "Đăng ký",
    "닉네임은 최대 12자까지 입력이 가능합니다.": "Biệt hiệu có thể dài tối đa 12 ký tự.",
    "이미 캠스콘 회원 이신가요?": "Đã là thành viên CAMSCON?",

    "비밀번호를 잊으셨거나, 변경하길 원하시나요?": "Bạn quên mật khẩu hoặc muốn thay đổi mật khẩu?",
    "비밀번호 재설정 이메일 발송하기": "Gửi email đặt lại mật khẩu",
    "입력하신 메일로 1시간 동안 유효한 비밀번호 재설정 링크를 발송해드립니다. (카카오로 가입한 회원은 재설정 불가)": "Chúng tôi sẽ gửi cho bạn một liên kết đặt lại mật khẩu có giá trị trong 1 giờ tới email bạn đã nhập. (Không thể đặt lại các thành viên đã đăng ký với KAKAO)",
    "입력한 메일 주소로 비밀번호 초기화 링크를 전송했습니다. 메일함을 확인해주세요.": "Một liên kết đặt lại mật khẩu đã được gửi đến địa chỉ email bạn đã nhập. Vui lòng kiểm tra hộp thư của bạn.",

    "비밀번호 변경": "Đổi mật khẩu",
    "이 메일을 통해 xxxxxxxx@xxx.com의 비밀번호를 변경하실 수 있습니다. 아래의 링크를 클릭하신 후 새롭게 사용할 비밀번호를 입력해주세요.": "Bạn có thể thay đổi mật khẩu cho xxxxxxxx@xxx.com qua email này. Vui lòng nhấp vào liên kết bên dưới và nhập mật khẩu mới.",
    "캠스콘 바로가기": "Đi tới CAMSCON",
    "XXXX년 XX월 XX일 XX시 XX분에 캠스콘 홈페이지를 통해 신청하신 비밀번호 재설정 요청에 따라 발송되었습니다. 이 메일은 1시간 동안 유효합니다": "Được gửi vào XX / XX / XXXX lúc XX: XX để phản hồi yêu cầu đặt lại mật khẩu của bạn thông qua trang web Camscon. Email này có hiệu lực trong 1 giờ",

    "업로드": "Tải lên",
    "업로드할 사진(jpg, png, gif)을 추가해 주세요.": "Hãy thêm ảnh để tải lên (jpg, png, gif)",
    "리스트에 없는 브랜드 추가 요청": "Yêu cầu thêm thương hiệu không có trong danh sách",
    "리스트에 없는 장소 추가 요청": "Yêu cầu thêm địa điểm không có trong danh sách",
    "다음": "Tiếp theo",
    "최대 50자까지(필수)": "Lên đến 50 ký tự (bắt buộc)",
    "서브타이틀은 최대 100자까지": "Phụ đề dài tối đa 100 ký tự",
    "사진에 대한 내용을 입력": "Mô tả nội dung về hình ảnh",
    "해시태그": "Gắn thẻ",
    "태그의 구분은 ','을 활용": "Sử dụng dấu “,” để phân loại thẻ",
    "촬영 장소": "Địa điểm chụp",
    "사진을 촬영한 장소를 입력": "Nhập vị trí chụp ảnh",
    "컬러": "Màu",
    "이 포스팅을 대표하는 컬러 혹은 첫 번째 이미지의 컬러를 선택": "Chọn màu đại diện cho bài đăng này hoặc màu của hình ảnh đầu tiên",
    "이전": "Về trước",
    "업로드": "Tải lên",

    "설정": "Cài đặt",
    "프로필 수정": "Chỉnh sửa hồ sơ",
    "비밀번호 변경": "Đổi mật khẩu",
    "의견보내기": "Gửi ý kiến",
    "이용가이드": "Hướng dẫn sử dụng",
    "공지사항": "Nội dung thông báo",

    "성별": "Giới tính",
    "선택안함": "Không chọn",
    "남성": "nam",
    "여성": "nữ",
    "생년월일": "Ngày sinh",
    "년": "Năm",
    "월": "tháng",
    "일": "ngày",
    "자기소개": "Giới thiệu bản thân",
    "최대 30자까지 입력 가능합니다.": "có thẻ nhập tối đa 30 chữ.",
    "인스타그램": "Instagram",
    "개인홈페이지": "Trang cá nhân",
    "캠스콘 탈퇴하기": "Hủy đăng ký CAMSCON",
    "수정하기": "Chỉnh sửa",
    "비밀번호 변경": "Đổi mật khẩu",
    "현재 비밀번호": "Mật khẩu hiện tại",
    "현재 비밀번호를 입력해주세요.": "Hãy nhập mật khẩu hiện tại.",
    "새로운 비밀번호 입력": "Nhập mật khẩu mới",
    "영문, 숫자, 특수문자 포함 8~25자": "8~25 ký tự bao gồm tiếng Anh, số và ký tự đặc biệt",
    "새로운 비밀번호 한번 더 입력": "Nhập lại mật khẩu mới",
    "예)홍길동": "thí dụ)Nguyễn Công Phượng",
    "사용자 의견": "Ý kiến người dùng",
    "선택, 예)example@gmail.com": "Lựa chọn, Ví dụ)example@gmail.com",
    "연락받으실 이메일": "Email để liên hệ",
    "선택, 예)example@gmail.com": "Lựa chọn, Ví dụ)example@gmail.com",
    "연락받으실 전화번호": "Số điện thoại liên hệ",
    "선택, 예)010-0000-0000": "Lựa chọn, Ví dụ)010-0000-0000",
    "개인정보 활용에 동의합니다.": "Tôi đồng ý với việc sử dụng thông tin cá nhân.",
    "보내기": "Gửi",

    "알림이 없습니다.": "Không có thông báo.",
    "회원님의 게시글에 댓글을 달았습니다.": "Có nhận xét về bài đăng của bạn.",
    "회원님의 사진을 좋아합니다.": "“Thích” ảnh của bạn.",
    "회원님을 팔로우 합니다.": ":Theo dõi bạn.",
}

